export const startChat = () => {
	window.openYabbrWidget();
};
